// extracted by mini-css-extract-plugin
export var empty = "carousel-module--empty--Jt4o+";
export var wrapper = "carousel-module--wrapper--dcJJ3";
export var carousel = "carousel-module--carousel--8LXzA";
export var button = "carousel-module--button--9OXdW";
export var fadein = "carousel-module--fadein--Uvnx6";